<template>
    <div class="row">
        <div class="col-sm-12">
            <span class="span-title">{{ text }}</span>
            <!-- set max so the browser won't allow future dates -->
            <input v-model="internal" type="date" class="form-control form-control-sm" :max="maxDate" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'EquipmentDate',
    props: {
        modelValue: {
            type: String,
            default: null
        },
        text: {
            type: String,
            default: null
        }
    },
    emits: ['update:modelValue'],
    computed: {
        internal: {
            get() {
                return this.modelValue
            },
            set(val) {
                // if somehow a future date is programmatically set here, clamp it
                if (val && this.maxDate && val > this.maxDate) {
                    this.$emit('update:modelValue', this.maxDate)
                } else {
                    this.$emit('update:modelValue', val)
                }
            }
        },
        // maxDate is today's date in local time formatted as yyyy-mm-dd
        maxDate() {
            const d = new Date()
            // adjust for timezone so toISOString gives local date correctly
            d.setMinutes(d.getMinutes() - d.getTimezoneOffset())
            return d.toISOString().slice(0, 10)
        }
    },
    watch: {
        modelValue(newVal) {
            if (newVal && this.maxDate && newVal > this.maxDate) {
                // clamp any externally provided future date
                this.$emit('update:modelValue', this.maxDate)
            }
        }
    },
    mounted() {
        // ensure initial value is not in the future
        if (this.modelValue && this.maxDate && this.modelValue > this.maxDate) {
            this.$emit('update:modelValue', this.maxDate)
        }
    }
}
</script>
